import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface RenewSubscriptionRequest {
  workspace_id: number;
}

export interface RenewSubscriptionResponse {
  success: boolean;
  message: string;
  renewal_method?: "reactivated_existing";
  stripe_subscription_id?: string;
  period_end?: number;
  action_required?: "create_new_subscription" | "update_payment_method";
  status?: string;
  cancelled_subscription_id?: string;
  missing_subscription_id?: string;
}

export const useRenewSubscription = () => {
  const userToken = useAuth()?.userToken ?? "";
  const { workspaceId } = useParams();

  return useMutation({
    mutationFn: async (): Promise<RenewSubscriptionResponse> =>
      fetch(ENDPOINTS.billing.renew_subscription(Number(workspaceId)), {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({}),
      }).then(handleResponse),
    onSuccess: () => {
      window.location.reload();
    },
  });
};
